import _ from 'lodash';

export default{
  createForUser: createForUser
}

function createForUser(mobilePhone){
  if(!mobilePhone) return {number: null, countryCode: null};

  let number = _.takeRight(mobilePhone, 10).join('');
  let countryCode = _.dropRight(mobilePhone, 10).join('').replace('+', '');

  return {
    number: !_.isEmpty(number) ? number : null,
    countryCode: !_.isEmpty(countryCode) ? countryCode : null
  };
}